import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppContextService } from '@partou/core';
import { map, type Observable } from 'rxjs';
import type { ApiDashboardStats, DashboardStatistics, DashboardStatisticsFilters } from '../types';
import { toDashboardStatistics } from '../mappers/dashboard.api';

const STATISTICS_ENDPOINT: Readonly<string> = '/dashboard/stats';

@Injectable()
export class DashboardApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly context: AppContextService = inject(AppContextService);

  getStatistics(filters: DashboardStatisticsFilters): Observable<DashboardStatistics> {
    let params: HttpParams = new HttpParams();
    if (filters.locationId !== null) params = params.set('locationId', filters.locationId);
    if (filters.groupId !== null) params = params.set('groupId', filters.groupId);
    return this.http
      .get<ApiDashboardStats>(this.context.buildEndpoint(STATISTICS_ENDPOINT), { params })
      .pipe(map(toDashboardStatistics));
  }
}
